import React, { HTMLAttributes, CSSProperties } from 'react';

type BoxProps = HTMLAttributes<HTMLElement> & {
    component?: React.ElementType;
    children?: React.ReactNode;
    className?: string;
    sx?: CSSProperties;
};

const Box = React.forwardRef<HTMLElement, BoxProps>(
    ({ component = 'div', children, className = '', sx, ...props }, ref) => {
        const Component = component as React.ElementType;

        // Merge sx styles with any existing style prop
        const combinedStyles = sx ? { ...props.style, ...sx } : props.style;

        return (
            <Component
                ref={ref}
                className={className}
                style={combinedStyles}
                {...props}
            >
                {children}
            </Component>
        );
    }
);

Box.displayName = 'Box';

export default Box;
